module.exports = __webpack_public_path__ + "img/thumbnail_Outlook-stbjr3qz.6f7a2b39.png";